import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { adminLogin } from '../services/api'; // Will create this function

const AdminLoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isExpired = new URLSearchParams(location.search).get('expired') === 'true';
  const isReset = new URLSearchParams(location.search).get('reset') === 'true';

  // Clear session if reset requested
  React.useEffect(() => {
    if (isReset) {
      localStorage.clear();
      window.history.replaceState({}, '', '/admin/login');
    }
  }, [isReset]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    const params = new URLSearchParams();
    params.append('username', formData.email);
    params.append('password', formData.password);

    try {
      await adminLogin(params);
      navigate('/admin'); // Redirect to admin dashboard
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="light-theme-page">
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body p-4">
                <h3 className="card-title text-center mb-4">Ingreso de administrador</h3>
                <form onSubmit={handleSubmit}>
                  {isExpired && <div className="alert alert-warning">Su sesión ha expirado. Por favor, inicie sesión nuevamente.</div>}
                  {error && <div className="alert alert-danger">{error}</div>}

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Correo electrónico</label>
                    <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Contraseña</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                      </button>
                    </div>
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      Ingresar como administrador
                    </button>
                  </div>
                </form>
                <div className="text-center mt-3">
                  <p>
                    ¿No tienes una cuenta de administrador? <a href="/admin/register">Regístrate aquí</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
